module.exports = __webpack_public_path__ + "img/200.1a595e25.jpg";